import { financeOperatorsApi } from 'entities/financeOperations/model';
import { HTTP_METHODS } from 'shared/consts';
import { IFinanceOperatorsItem } from 'entities/financeOperations/types';

type GetFinanceOperationsByIdParams = {
  id?: string;
};

const getFinanceOperatorsApi = financeOperatorsApi.injectEndpoints({
  endpoints: (builder) => ({
    getFinanceOperators: builder.query<IFinanceOperatorsItem[], null>({
      query: () => ({
        url: '/wallet/admin/withdrawal_services_types/',
        method: HTTP_METHODS.GET,
      }),
      providesTags: ['FinanceOperations'],
    }),
    getFinanceOperationsById: builder.query<IFinanceOperatorsItem, GetFinanceOperationsByIdParams>({
      query: ({ id }) => ({
        url: `/wallet/admin/withdrawal_services_types/${id}/`,
        method: HTTP_METHODS.GET,
      }),
      providesTags: ['FinanceOperationId'],
    }),
  }),
});

export const { useGetFinanceOperatorsQuery, useGetFinanceOperationsByIdQuery } = getFinanceOperatorsApi;
